import React from "react";
import { RecoilRoot } from "recoil";
import { AppRoutes } from "./routes";
import "./App.css";
import "react-calendar/dist/Calendar.css";
import { AuthProvider } from "./components/AuthContext";
import { Toaster } from "react-hot-toast";

const App = () => (
    <RecoilRoot>
        <Toaster />
        <AuthProvider>
            <AppRoutes />
        </AuthProvider>
    </RecoilRoot>
);

export default App;
